import React from 'react';

const CourseHeader = () => {
    return (
        <header className="bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 text-white py-4 shadow-md">
            <div className="container mx-auto px-4">
                <div className="flex flex-wrap items-center justify-center">
                    <div className="w-full text-center h-48 mt-12">
                        <h1 className="font-bold text-2xl md:text-3xl mb-2">Mastering IELTS Writing Task 2</h1>
                        <p className="text-sm md:text-base leading-tight">
                            Boost your IELTS Writing Task 2 score with our comprehensive course, including tips, strategies, and
                            mock tests to help you succeed.
                        </p>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default CourseHeader;
